/** @private, do not use this method in components, use lower level fields instead */
export const __getCommonData = (state) => state.common;
export const getCommonSettingsData = (state) => state.settings;
export const getBodyData = (state) => state.body;
export const getHeaderData = (state) => state.header;
export const getFooterData = (state) => state.footer;
export const getWidgetsData = (state) => state.widgets;
export const getEULAData = (state) => state.EULA;
export const getTradeInStore = (state) => state.tradeIn;
